import React from "react";
import { useAuth } from 'react-oidc-context';
import { UserManager } from 'oidc-client-ts';
import { ENDPOINT_REGISTRO } from '../../auth-config';

import './Login.css';

import LogoAuth from '../../img/logoV2.png';
import Cargando from "../../img/Cargando.gif";

// Pantalla de entrada. Antes este archivo tenía 775 líneas: un asistente de
// seis pasos que implementaba alta, código de verificación, perfil, contraseña
// temporal, recuperación y enlace de cuentas sociales, todo contra Cognito.
//
// Ahora esas pantallas las sirve Keycloak. Lo que queda aquí es la decisión de
// a dónde mandar al usuario, y nada más. Con ello se van también los problemas
// que vivían en ese asistente: el handler que se disparaba dos veces por clic,
// los tres puntos de abandono que dejaban la cuenta inservible, la contraseña
// aleatoria que nadie podía conocer y el autoSignIn que se colgaba sin
// resolver nunca.
//
// Las props se conservan para no tocar NavBar ni la ruta /login; setModalLogin
// se usa para cerrar la modal antes de redirigir.
const Login = ({ setModalLogin, pagina })=>{
    const auth = useAuth();

    const ir = (extra = {}) => {
        if (setModalLogin) setModalLogin(false);
        // Guarda dónde estaba para volver ahí tras autenticar. Keycloak regresa
        // a redirect_uri, que es la raíz, así que el destino lo recordamos aquí.
        try {
            sessionStorage.setItem('destinoTrasLogin', window.location.pathname + window.location.search);
        } catch (e) { /* modo privado */ }
        auth.signinRedirect(extra);
    };

    // El alta usa el endpoint de registro de Keycloak en vez de prompt=create,
    // que Keycloak reenviaba a Google y Google rechazaba. Se construye un
    // UserManager con los MISMOS ajustes y solo se le cambia el endpoint de
    // autorizacion: asi el PKCE, el state y el almacenamiento son identicos a
    // los del login, y el callback lo resuelve el AuthProvider de siempre.
    const registrarse = () => {
        if (setModalLogin) setModalLogin(false);
        try {
            sessionStorage.setItem('destinoTrasLogin', window.location.pathname + window.location.search);
        } catch (e) { /* modo privado */ }

        try {
            new UserManager({
                ...auth.settings,
                metadataSeed: { authorization_endpoint: ENDPOINT_REGISTRO },
            }).signinRedirect();
        } catch (e) {
            // Si algo falla, el login normal tambien ofrece "Registrate".
            auth.signinRedirect();
        }
    };

    if (auth.isLoading) {
        return (
            <div className={'pc-auth' + (pagina ? ' pc-auth--solo' : '')}>
                <div className="pc-auth__brand">
                    <img src={LogoAuth} alt="PalletCloud" className="pc-auth__logo"/>
                    <p className="pc-auth__eyebrow">
                        <span className="pc-auth__spinner"><img src={Cargando} alt=""/></span>
                        Conectando…
                    </p>
                </div>
            </div>
        );
    }

    return(
        <div data-tour="auth-inicio" className={'pc-auth' + (pagina ? ' pc-auth--solo' : '')}>
            <div className="pc-auth__brand">
                <img src={LogoAuth} alt="PalletCloud" className="pc-auth__logo"/>
                <p className="pc-auth__eyebrow">INICIA SESIÓN O REGÍSTRATE</p>
                <h2 className="pc-auth__title">¡Bienvenido a PalletCloud!</h2>
                <p className="pc-auth__subtitle">Usa tu correo o una cuenta social para continuar</p>
            </div>

            <div className="pc-auth__body">
                {auth.error &&
                    <div className="pc-auth__error">No pudimos iniciar sesión: {auth.error.message}</div>
                }

                <button type="button" data-tour="btn-continuar" className="pc-auth__btn" onClick={()=> ir()}>
                    Iniciar sesión
                </button>

                <button type="button" className="pc-auth__btn pc-auth__btn--sec"
                        onClick={()=> registrarse()}>
                    Crear cuenta
                </button>

                <p className="pc-auth__legal">
                    Al continuar aceptas los <a href="http://file.palletcloud.io/TERMINOS.pdf" target="_blank" rel="noreferrer">Términos</a>,
                    la <a href="http://file.palletcloud.io/PRIVACIDAD.pdf" target="_blank" rel="noreferrer">Privacidad</a> y
                    el <a href="http://file.palletcloud.io/DATOS.pdf" target="_blank" rel="noreferrer">Consentimiento de datos</a>.
                </p>
            </div>
        </div>
    );
}

export default Login;
